export default function requestData(state = {}, action = null) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case 'WS_SCRIPTS_SET_REQUEST_DATA':
				return action.payload;

			// no default
		}
	}

	return state;
}
